// extracted by mini-css-extract-plugin
module.exports = {"TeacherInterview":"Htm0TB3aTlt3NDWE6Y9Th"};